export enum TipoSoggettoAnagrafeEnum {
  AMMINISTRAZIONE = <any>"AMMINISTRAZIONE",
  AOO = <any>"AOO",
  UFFICIO = <any>"UFFICIO",
  ASSOCIAZIONE = <any>"ASSOCIAZIONE",
  CITTADINO = <any>"CITTADINO",
  IMPRESA = <any>"IMPRESA",
  AMMINISTRAZIONE_NON_IPA = <any>"AMMINISTRAZIONE_NON_IPA",
  SOGGETTO_STRANIERO = <any>"SOGGETTO_STRANIERO",
}
